"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddButton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function AddButton(_ref) {
  let {
    context,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Add ".concat(context)
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Add.default, null)));
}
AddButton.propTypes = {
  context: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};